const getMoedaFilterFields = () => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'sigla', label: 'Sigla' },
  { name: 'descricao', label: 'Descrição', initial: true },
];

export default getMoedaFilterFields;
